<template>
  <el-dialog title="添加账户" :visible.sync="dialog" width="445px">
    <div>
      <el-form label-width="90px" label-position="right">
        <el-row style="padding-left:10px">
          <el-col>
            <el-form-item label="账号名称：" :rules="filter_rules({required:true})">{{qupryParms.suName}}</el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="银行账号：" :rules="filter_rules({required:true})">
              <el-input v-model.trim="qupryParms.bankCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="开户行：" :rules="filter_rules({required:true})">
              <el-input v-model.trim="qupryParms.bankOpencount"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="银行行号：" >
              <el-input v-model.trim="qupryParms.bankOpenCode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="edit">确 定</el-button>
      <el-button @click="dialog = false">取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { addBank } from '@/api/supplier/supplierManage'

export default {
  data () {
    return {
      dialog: false,
      receiptName: '',
      qupryParms: {
        suId: ''

      },
      cusName: ''
    }
  },
  methods: {
    onInitialize (name, id) {
      this.qupryParms = {
        suId: ''

      }
      this.dialog = true
      this.qupryParms.suId = id
      this.qupryParms.suName = name
    },
    // 确认
    edit () {
      if (!this.qupryParms.bankOpencount || !this.qupryParms.bankCode) {
        this.$message.error('添加失败,必填项不能为空!')
      } else {
        addBank(this.qupryParms).then(res => {
          if (res.data.code === 200) {
            this.dialog = false
            this.$emit('onFrech')
            this.$message.success('操作成功')
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(err => {
          console.log(err)
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
